import { animate, group, query, state, style, transition, trigger } from '@angular/animations';

export const overlayAnimations = [
  trigger('overlayAnimations', [
    transition(':enter', [
      group([
        query('.progress-bar', [
          style({ width: '0%' }),
          animate('4500ms ease-out', style({ width: '100%' })),
        ]),
      ]),
    ]),
    transition(':leave', [style({ opacity: 1 }), animate('300ms ease-in', style({ opacity: 0 }))]),
  ]),
  trigger('fadeIn', [
    state('void', style({ opacity: 0 })),
    transition(':leave', [animate(4200, style({ opacity: 1 }))]),
  ]),
];
